// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

export const StoneCrystalTranslationFragmentDoc = `
    fragment stoneCrystalTranslation on StoneCrystalTranslation {
  name
}
    `;